import { BaseRouteService } from 'core/services';

class ImportReferenceRouteService extends BaseRouteService {
    constructor() {
        super('import-reference');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,importReferenceTypeIds,isActive,insuranceId}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }
    
    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }
    
    download(filter) {
        return super.find(this.base + '/download/{?searchQuery,sort}', filter);    
    }

    upload(resource){
        return super.create(this.base + '/upload', resource);
    }
}

export default ImportReferenceRouteService;
